import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { AppStore } from 'stores';

const PrintService = {
  printElementToPDF: (element, filename) => {
    if (!element) return;

    const printWidth = element.offsetWidth;
    const printHeight = element.offsetHeight;

    html2canvas(element, {
      scale: 2, // Higher scale for better quality
      useCORS: true, // Try to load cross-origin images
      allowTaint: true,
      scrollX: 0,
      scrollY: 0,
    })
      .then((canvas) => {
        const imgData = canvas.toDataURL('image/jpeg', 0.95);

        const orientation = printWidth > printHeight ? 'l' : 'p';
        const pdf = new jsPDF(orientation, 'pt', [printWidth, printHeight]);

        pdf.addImage(imgData, 'JPEG', 0, 0, printWidth, printHeight);

        const pdfBlob = pdf.output('blob');
        const blobUrl = URL.createObjectURL(pdfBlob);

        const printWindow = window.open(blobUrl, '_blank');

        if (!printWindow) {
          AppStore.addError(
            'Popup Blocked, Please allow popups for this website to print PDF.'
          );
          pdf.save(filename || 'download.pdf');
          return;
        }

        printWindow.onload = function () {
          printWindow.print();

          const downloadLink = document.createElement('div');
          downloadLink.style.textAlign = 'center';
          downloadLink.style.marginTop = '20px';
          downloadLink.innerHTML = `
          <p>If the print dialog did not appear or you want to download the PDF, 
          <a href="${blobUrl}" download="${filename || 'download.pdf'}" 
             style="color: blue; text-decoration: underline; cursor: pointer;">
             click here to download
          </a></p>
        `;

          printWindow.document.body.appendChild(downloadLink);
        };
      })
      .catch(() => {
        AppStore.addError(
          'PDF Generation Failed, There was an error creating your PDF. Please try again.'
        );
      });
  },
};

export default PrintService;
